import {block} from '../utils/cn';

export const b = block('stepper');
